export function buildMailtoOfferRequest ({ productDescription, language }) {
  const salutations = {
    de: 'Sehr geehrte Damen und Herren,',
    en: 'Dear Sir or Madam,'
  }

  const bodyCopys = {
    de: 'bitte senden Sie uns ein Angebot zu folgendem Produkt zu:',
    en: 'plese send us an offer of the following product:'
  }

  const subjects = {
    de: 'Anfrage Kabelkonfigurator',
    en: 'Offer Request Cable Configurator'
  }

  let salutation = salutations[language] || salutations.de
  let bodyCopy = bodyCopys[language] || bodyCopys.de
  let subject = subjects[language] || subjects.de
  
  const template = `${salutation}

${bodyCopy}
${productDescription}

`

  const mailToTemplate = `mailto:anfrage@sachsenkabel.de?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(template)}`

  return mailToTemplate
}